import * as yup from 'yup'
import { REQUIRED_FIELD } from 'constants/errors'

export const schemaHoliday = yup.object().shape({
  date: yup.string().nullable().required(REQUIRED_FIELD),
  isRepeated: yup.boolean(),
  description: yup.string(),
})
